module.exports = __webpack_public_path__ + "img/association02.cf2bf394.png";